import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import PublicNavbar from '@/components/layout/PublicNavbar';
import PublicFooter from '@/components/layout/PublicFooter';
import { ShoppingBag, Briefcase, CheckCircle2, Award, Star, ArrowRight, ChevronLeft, ChevronRight, Calendar, Package, Boxes, Settings, User } from 'lucide-react';

const PARTNER_BRANDS = [
  {
    id: 1,
    name: 'Simbiot',
    logo: '/logo/1.jpg',
    image: '/Product Brand/Product Simbiot.png',
    description: 'Parfum dengan ketahanan wangi luar biasa yang dirancang untuk menemani padatnya aktivitas harian Anda tanpa batas.',
    category: "Extrait de Parfum",
    sku: '5+',
    year: '2025',
    link: 'https://shopee.co.id/simbiot_store'
  },
  {
    id: 2,
    name: 'Gamal',
    logo: '/logo/2.jpg',
    image: '/Product Brand/Product gamal.png',
    description: 'Wewangian maskulin yang dirancang khusus untuk merepresentasikan karakter dan identitas pria yang berkelas.',
    category: 'Extrait de Parfum',
    sku: '2+',
    year: '2024',
    link: 'https://shopee.co.id/gamal.men'
  },
  {
    id: 3,
    name: 'Meet The Makers',
    logo: '/logo/3.jpg',
    image: '/Product Brand/Product meet the makers.png',
    description: 'Koleksi aroma kontemporer yang sangat cocok untuk melengkapi gaya hidup dinamis para generasi muda saat ini.',
    category: 'Eau de Parfum',
    sku: '3+',
    year: '2025',
    link: 'https://shopee.co.id/meetthemakers'
  },
  {
    id: 4,
    name: 'Meet Me At The Altar',
    logo: '/logo/4.jpg',
    image: '/Product Brand/Product meet me altar.png',
    description: 'Menghadirkan keharuman unik, mulai dari sentuhan wangi yang manis hingga kelembutan botanical yang elegan.',
    category: 'Extrait de Parfum',
    sku: '6+',
    year: '2025',
    link: 'https://shopee.co.id/altar.scents'
  },
  {
    id: 5,
    name: 'Manifest',
    logo: '/logo/5.jpg',
    image: '/Product Brand/Product Manifest.png',
    description: 'Parfum yang diformulasikan secara khusus untuk membantu memancarkan energi, frekuensi, serta aura yang positif.',
    category: 'Eau de Parfum',
    sku: '2',
    year: '2025',
    link: 'https://shopee.co.id/manifest.co.id#product_list'
  },
  {
    id: 6,
    name: 'Maison Garnet',
    logo: '/logo/6.jpg',
    image: '/Product Brand/Product Maison Garnet.png',
    description: 'Wewangian dengan konsep olfactory storytelling yang terinspirasi langsung dari memori dan momen paling bermakna.',
    category: 'Eau de Parfum',
    sku: '3',
    year: '2025',
    link: 'https://shopee.co.id/maisongarnet?categoryId=100632&entryPoint=ShopByPDP&itemId=27430295189'
  },
  {
    id: 7,
    name: 'Tomolab',
    logo: '/logo/7.jpg',
    image: '/Product Brand/Product Tomolab.png',
    description: 'Menghadirkan kreasi aroma yang eksentrik untuk menonjolkan karakter unik yang berani tampil berbeda.',
    category: 'Eau de Parfum',
    sku: '3',
    year: '2025',
    link: 'https://shopee.co.id/tomolab.id'
  },
  {
    id: 8,
    name: 'Valord',
    logo: '/logo/8.jpg',
    image: '/Product Brand/Product Valord.png',
    description: 'Koleksi parfum maskulin dan elegan yang dirancang secara khusus untuk memberikan kesan berkelas bagi penggunanya.',
    category: 'Extrait de Parfum',
    sku: '12',
    year: '2025',
    link: 'https://shopee.co.id/decant'
  },
  {
    id: 9,
    name: 'Kokulu',
    logo: '/logo/9.jpg',
    image: '/Product Brand/Product Kokulu.png',
    description: 'Parfum andalan dengan konsentrat asli Eropa yang menjamin keharuman mewah, elegan, serta ketahanan luar biasa.',
    category: 'Eau de Parfum',
    sku: '55',
    unitLabel: 'Varian',
    year: '2024',
    link: 'https://shopee.co.id/kokulu.official?entryPoint=ShopBySearch&searchKeyword=kokulu'
  },
  {
    id: 10,
    name: 'Fonce',
    logo: '/logo/10.jpg',
    image: '/Product Brand/Product Fonce.png',
    description: 'Aroma unisex yang menyegarkan dan menenangkan, memberikan kualitas premium yang tetap sangat terjangkau.',
    category: 'Extrait de Parfum',
    sku: '9',
    year: '2025',
    link: 'https://shopee.co.id/fonce.id?entryPoint=ShopBySearch&searchKeyword=fonce'
  },
  {
    id: 11,
    name: 'Bhirama',
    logo: '/logo/11.jpg',
    image: '/Product Brand/Product Bhirama.png',
    description: 'Parfum berkarakter kuat dengan nuansa Timur Tengah klasik yang memberikan pesona misterius dan memikat.',
    category: 'Extrait de Parfum',
    sku: '21',
    unitLabel: 'Varian',
    year: '2024',
    link: 'https://shopee.co.id/bhiramaofficial'
  },
  {
    id: 12,
    name: 'Superdope',
    logo: '/logo/12.jpg',
    image: '/Product Brand/Product Superdope.png',
    description: 'Parfum pria eksklusif dengan aroma bold dan sangat intense yang siap untuk mendominasi penampilan keseharian Anda.',
    category: 'Eau de Parfum',
    sku: '2',
    year: '2025',
    link: 'https://shopee.co.id/superdope.project'
  }
];

export default function PartnerPage() {
  const navigate = useNavigate();
  const [activeBrandIdx, setActiveBrandIdx] = useState(0);
  const activeBrand = PARTNER_BRANDS[activeBrandIdx];

  const handleNext = () => {
    setActiveBrandIdx((prev) => (prev + 1) % PARTNER_BRANDS.length);
  };

  const handlePrev = () => {
    setActiveBrandIdx((prev) => (prev === 0 ? PARTNER_BRANDS.length - 1 : prev - 1));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="min-h-screen bg-[#FFFDF9] text-[#4A3B32] font-sans selection:bg-[#D4AF37] selection:text-white">
        <PublicNavbar />

        {/* Hero Section */}
        <section className="relative pt-20 pb-32 px-6 lg:px-12 overflow-hidden bg-[#F9F5EC]" data-aos="fade-up">
          {/* Background Image / Overlay */}
          <div className="absolute right-0 top-0 bottom-0 w-full lg:w-[60%] opacity-30 lg:opacity-100 z-0">
            <img src="/Gambar Web/Brand mitra.png" alt="Brand Bermitra" className="w-full h-full object-cover object-right mask-image-gradient-left" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#F9F5EC] via-[#F9F5EC]/80 to-transparent"></div>
          </div>

          <div className="container mx-auto max-w-7xl relative z-10">
            <div className="w-full lg:w-1/2 pt-10">
              <span className="inline-block py-1.5 px-4 bg-[#E6D5B8]/40 text-[#8C6208] text-xs font-bold tracking-widest uppercase rounded-full mb-6">
                Dipercaya Banyak Brand
              </span>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 leading-[1.1] text-[#302621]">
                Brand Yang <br /> Telah Bermitra
              </h1>
              <p className="text-lg text-[#7A695B] mb-10 leading-relaxed max-w-md font-light">
                Dipercaya oleh berbagai brand parfum lokal dan internasional untuk mengembangkan produk berkualitas dan bertumbuh bersama.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button size="lg" className="bg-[#D4AF37] hover:bg-[#B58B22] text-white px-8 py-6 text-base rounded-lg shadow-lg shadow-[#D4AF37]/20 border-0 transition-transform hover:-translate-y-1">
                  Konsultasi Sekarang <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
                <Button size="lg" variant="outline" className="border-[#302621] text-[#302621] bg-transparent hover:bg-[#302621] hover:text-white px-8 py-6 text-base rounded-lg transition-transform hover:-translate-y-1">
                  Lihat Produk Kami
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Row */}
        <section className="relative -mt-16 px-6 lg:px-12 z-20" data-aos="fade-up">
          <div className="container mx-auto max-w-6xl">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
              {[
                { count: "150+", label: "Brand Kosmetik", icon: <Award /> },
                { count: "500+", label: "Variant Unggulan", icon: <Boxes /> },
                { count: "100rb+", label: "Produk Terjual", icon: <Settings /> },
                { count: "99%", label: "Legalitas Terjamin", icon: <CheckCircle2 /> }
              ].map((stat, idx) => (
                <div key={idx} className="bg-white p-6 md:p-8 rounded-2xl shadow-xl shadow-[#302621]/5 border border-[#E6D5B8]/30 flex items-center gap-5 hover:-translate-y-1 transition-transform">
                  <div className="w-12 h-12 shrink-0 rounded-full bg-[#F9F5EC] flex items-center justify-center text-[#D4AF37]">
                    {stat.icon}
                  </div>
                  <div>
                    <h3 className="text-2xl md:text-3xl font-black text-[#302621]">{stat.count}</h3>
                    <p className="text-[10px] md:text-xs text-[#7A695B] font-bold uppercase tracking-wider">{stat.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Interactive Brand Section */}
        <section className="py-24 px-6 lg:px-12 bg-[#FFFDF9]" data-aos="fade-up">
          <div className="container mx-auto max-w-6xl text-center">
            <span className="inline-block py-1.5 px-4 bg-[#E6D5B8]/40 text-[#8C6208] text-xs font-bold tracking-widest uppercase rounded-full mb-4">
              DIPERCAYA BANYAK BRAND
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#302621] mb-4">Brand yang Telah Bermitra</h2>
            <p className="text-[#7A695B] mb-12 max-w-2xl mx-auto">
              Bersama berbagai brand parfum, kami menghadirkan produk berkualitas dan bertumbuh bersama.
            </p>
            
            {/* 6x2 Logos Grid */}
            <div className="grid grid-cols-3 md:grid-cols-6 gap-4 md:gap-6 mb-16 justify-items-center">
              {PARTNER_BRANDS.map((brand, idx) => (
                <div key={brand.id} className="flex flex-col items-center w-full group">
                  <div 
                    onClick={() => setActiveBrandIdx(idx)}
                    className={`aspect-square w-full flex items-center justify-center rounded-2xl transition-all duration-300 cursor-pointer border-2 mb-3 ${
                      activeBrandIdx === idx 
                        ? 'border-[#D4AF37] bg-white shadow-lg grayscale-0 opacity-100 scale-105' 
                        : 'border-transparent bg-white/50 shadow-sm grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 group-hover:shadow-md group-hover:border-[#E6D5B8] group-hover:scale-105'
                    }`}
                  >
                    <img src={brand.logo} alt={brand.name} className="max-h-[70%] max-w-[80%] object-contain" style={{ mixBlendMode: 'multiply' }} />
                  </div>
                  <span className="text-[#302621] text-xs md:text-sm font-bold text-center px-2 transition-all" style={{ fontFamily: "'Glacial Indifference', sans-serif" }}>{brand.name}</span>
                </div>
              ))}
            </div>

            {/* Active Brand Highlight Card */}
            <div className="relative max-w-5xl mx-auto">
              {/* Navigation Arrows (Outside) */}
              <button 
                onClick={handlePrev}
                className="absolute -left-4 md:-left-16 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white border border-[#E6D5B8]/50 hover:bg-[#F9F5EC] text-[#302621] flex items-center justify-center shadow-lg transition-all z-10"
              >
                <ChevronLeft className="w-6 h-6" />
              </button>
              <button 
                onClick={handleNext}
                className="absolute -right-4 md:-right-16 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white border border-[#E6D5B8]/50 hover:bg-[#F9F5EC] text-[#302621] flex items-center justify-center shadow-lg transition-all z-10"
              >
                <ChevronRight className="w-6 h-6" />
              </button>

              <div className="bg-white border border-[#E6D5B8]/50 rounded-[2rem] overflow-hidden shadow-xl shadow-[#302621]/5 text-left">
                <AnimatePresence mode="wait">
                  <motion.div 
                    key={activeBrand.id}
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    transition={{ duration: 0.3 }}
                    className="flex flex-col md:flex-row w-full"
                  >
                    <div className="w-full md:w-[60%] shrink-0 relative">
                      <img src={activeBrand.image} alt="" className="w-full h-auto block opacity-0 pointer-events-none" aria-hidden="true" />
                      <img src={activeBrand.image} alt={activeBrand.name} className="absolute inset-0 w-full h-full object-cover object-center" />
                    </div>
                    
                    <div className="w-full md:w-[40%] p-6 md:p-10 lg:p-12 flex flex-col justify-center">
                      <span className="inline-block py-1 px-3 bg-[#F9F5EC] text-[#8C6208] text-[10px] font-bold tracking-widest uppercase rounded mb-3 w-fit border border-[#E6D5B8]/50">
                        MITRA BRAND
                      </span>
                      <h3 className="text-3xl md:text-4xl font-bold text-[#302621] mb-4">{activeBrand.name}</h3>
                      <p className="text-[#7A695B] leading-relaxed mb-6 text-sm md:text-base">
                        {activeBrand.description}
                      </p>
                      
                      <div className="flex flex-wrap gap-4 md:gap-5 mb-8">
                        <div className="flex items-center gap-3">
                          <div className="w-10 h-10 rounded-full bg-[#F9F5EC] flex items-center justify-center text-[#D4AF37] shrink-0">
                            <Package className="w-5 h-5" />
                          </div>
                          <div>
                            <p className="text-[10px] text-[#7A695B] font-semibold uppercase tracking-wider mb-0.5">{activeBrand.unitLabel || 'Produk'}</p>
                            <p className="font-bold text-[#302621] text-xs md:text-sm">{activeBrand.sku} {activeBrand.unitLabel || 'Produk'}</p>
                          </div>
                        </div>

                        <div className="flex items-center gap-3">
                          <div className="w-10 h-10 rounded-full bg-[#F9F5EC] flex items-center justify-center text-[#D4AF37] shrink-0">
                            <Calendar className="w-5 h-5" />
                          </div>
                          <div>
                            <p className="text-[10px] text-[#7A695B] font-semibold uppercase tracking-wider mb-0.5">Bermitra</p>
                            <p className="font-bold text-[#302621] text-xs md:text-sm">{activeBrand.year}</p>
                          </div>
                        </div>
                      </div>
                      
                      <div className="flex flex-wrap gap-4">
                        <a href={activeBrand.link} target="_blank" rel="noopener noreferrer">
                          <Button className="bg-[#D4AF37] hover:bg-[#B58B22] text-white px-6 md:px-8 py-5 md:py-6 rounded-xl shadow-lg shadow-[#D4AF37]/20 border-0 transition-transform hover:-translate-y-1">
                            Visit & Shop <ArrowRight className="w-4 h-4 ml-2" />
                          </Button>
                        </a>
                      </div>
                    </div>
                  </motion.div>
                </AnimatePresence>
              </div>
            </div>
          </div>
        </section>



        {/* Testimonials */}
        <section className="py-24 px-6 lg:px-12 bg-[#FCFAF6] border-y border-[#E6D5B8]/30" data-aos="fade-up">
          <div className="container mx-auto max-w-6xl text-center">
            <h2 className="text-3xl font-bold text-[#302621] mb-16">Apa Kata Mitra Kami</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-left">
              {[
                { brand: "Minelux", text: "Proses maklon berjalan sangat lancar. Tim profesional, responsif, dan hasil produknya sangat memuaskan!", name: "Adnan Hasan", role: "Consultant Minelux" },
                { brand: "MUV", text: "Sangat terbantu mulai dari riset formulasi hingga produksi. Parfum kami diterima sangat baik oleh pasar.", name: "Irwan Masduki", role: "CEO MUV" },
                { brand: "Oudixa", text: "Quality control yang ketat dan standar produksi tinggi membuat kami yakin bekerja sama jangka panjang.", name: "Husein", role: "Manager Oudixa" }
              ].map((t, idx) => (
                <div key={idx} className="bg-white p-8 rounded-2xl shadow-sm border border-[#E6D5B8]/40">
                  <div className="w-16 h-16 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center font-bold text-gray-400 mb-6 uppercase text-sm">
                    <User className="w-8 h-8 text-gray-400" />
                  </div>
                  <div className="flex gap-1 mb-4 text-[#D4AF37]">
                    {[1,2,3,4,5].map(s => <Star key={s} className="w-4 h-4 fill-current" />)}
                  </div>
                  <p className="text-[#4A3B32] text-sm leading-relaxed mb-8">"{t.text}"</p>
                  <div>
                    <h5 className="font-bold text-[#302621] text-sm">{t.name}</h5>
                    <p className="text-xs text-[#7A695B]">{t.role}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Dots */}
            <div className="flex justify-center gap-2 mt-12">
              <div className="w-2 h-2 rounded-full bg-[#D4AF37]"></div>
              <div className="w-2 h-2 rounded-full bg-[#E6D5B8]"></div>
              <div className="w-2 h-2 rounded-full bg-[#E6D5B8]"></div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 px-6 lg:px-12 bg-white" data-aos="fade-up">
          <div className="container mx-auto max-w-6xl">
            <div className="bg-[#EFE8D8] rounded-3xl overflow-hidden relative shadow-sm border border-[#E6D5B8]/50">
              <div className="absolute right-0 top-0 bottom-0 w-1/2 opacity-100 mix-blend-multiply hidden md:block">
                <img src="/Gambar Web/Botol berdiri.png" alt="Products" className="w-full h-full object-cover mask-image-gradient-left" />
              </div>
              <div className="relative z-10 p-12 md:p-16 w-full md:w-[55%] lg:w-1/2">
                <h2 className="text-3xl md:text-4xl font-bold text-[#302621] mb-4">Siap Membangun Brand Anda?</h2>
                <p className="text-[#7A695B] text-lg leading-relaxed mb-8">
                  Mulai perjalanan brand parfum Anda bersama tim ahli yang berpengalaman dalam formulasi, produksi, dan pengembangan produk.
                </p>
                <Button size="lg" className="bg-[#D4AF37] hover:bg-[#B58B22] text-white px-8 py-6 text-base rounded-lg shadow-md border-0 transition-transform hover:-translate-y-1">
                  Konsultasi Sekarang <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <PublicFooter />
      </div>
    </>
  );
}
